module.exports = __webpack_public_path__ + "img/indeximg1.9fbeeed5.png";